window.invoice_searcher = function (match_user_id, data_source, search_in_id) {
    return function (req, resp) {
        var m;
        var term = req.term.replace(/^\d+\s*,\s*/, '').replace(/\s*\([^)]*\)/g, '');
        var ca = [],
            search = strip_accents(term.toLowerCase().replace(/^\s*|\s*$/g, '')).split(/\s+/);
        var id = ((m = req.term.match(/^(\d+)\s*,/)) ? m[1] : null);
        var user_id = ((m = ($("input[name=user_id]").val() || "").match(/^(\d+)\s*,/)) ? m[1] : null);
        $.each(data_source, function (k, v) {
            var n = (v.name !== null ? strip_accents(v.name.toLowerCase()) : "")
                + " " + (v.email ? strip_accents(v.email.toLowerCase()) : "")
                + " " + (search_in_id === true ? v.id : "");
            match = (id ? id == v.id : true);
            if (match && match_user_id && user_id && v.user_id != user_id) {
                match = false;
            }
            if (match) {
                $.each(search, function (k, v) {
                    if (n.indexOf(v) == -1) {
                        match = false;
                    }
                });
            }
            if (match) {
                ca.push(v.id + ", " + v.name + (v.email !== undefined ? " (" + v.email + ")" : ""));
                if (ca.length > 100) {
                    return false;
                }
            }
        });
        resp(ca);
    };
};
